import preventDefault from '@mailobj-browser/front/js/events/hooks/preventDefault.js'
import listener from '@mailobj-browser/front/js/events/listeners/listener.js'
import once from '@mailobj-browser/front/js/events/options/once.js'
import passive from '@mailobj-browser/front/js/events/options/passive.js'
import click from '@mailobj-browser/front/js/events/types/click.js'
import input from '@mailobj-browser/front/js/events/types/input.js'
import { submit } from '@mailobj-browser/front/js/events/types/types.js'
import one from '@mailobj-browser/front/js/selectors/one.js'
import array from '@mailobj-browser/front/js/utils/array.js'
import object from '@mailobj-browser/front/js/utils/object.js'
import { fromEvent } from '#utilities/js/ea/ajax.js'
import { list } from '#utilities/js/fs/field.js'
import * as styles from '../xfiles/styles.js'
import { move } from './paired.js'

const onClick = object(listener, {
  type: click,
  passive,
  task: (button) => {
    const { dataset, ownerDocument } = button
    const { target } = dataset
    const input = one(target, ownerDocument)
    
    onInput.listen(input)
    input.click()
  }
})

const onInput = object(listener, {
  type: input,
  once,
  passive,
  task: async (
    input
  ) => {
    const { form, value } = input
    
    if (!value) {
      onInput.listen(input)
      
      return
    }
    
    const uploads = one(`.${styles.elements.xfiles_uploads}`, form)
    
    await list(input, uploads, styles)
    onSubmit.listen(form)
    onSubmit.trigger(form)
  }
})

const onSubmit = object(listener, {
  type: submit,
  once,
  hooks: array([
    preventDefault
  ]),
  task: async (
    form,
    event
  ) => {
    const promise = fromEvent(form, event)
    
    move(form)
    
    await promise
  }
})

export default button => {
  onClick.listen(button)
}